import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

/** Cellule de tableau : petite icône grise devant la valeur (email, rôle…) */
export function IconCell({ icon: Icon, children }: { icon: LucideIcon; children: ReactNode }) {
  return (
    <td className="px-6 py-4">
      <div className="flex items-center gap-2 text-sm text-slate-600">
        <Icon className="w-4 h-4 text-slate-400" />
        {children}
      </div>
    </td>
  );
}
